import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';
import { isInPWAView } from '../components/Add2HS/PWAInstallButton';
import SupplementalDocument from '../components/SupplementalDocument';

const SupplementalDocumentView = ({ match }) => {
  const {
    params: { src, title },
  } = match;
  const history = useHistory();

  return (
    <>
      <SupplementalDocument document={{ src, title }} />

      {/* Display Back button for the PWA users */}
      {isInPWAView && (
        <Button onClick={() => history.go(-1)} variant="contained" color="primary">
          Back
        </Button>
      )}
    </>
  );
};

export default SupplementalDocumentView;
